import React, { useCallback, useContext } from 'react';
import { Upload, UploadProps } from 'antd';
import { Message, Button } from '@alifd/next';
import { BackStageContext } from '@/contexts/BackStageContext';
import axios from 'axios';

const UploadExcel: React.FC = () => {
  const { setBackStageUpdateTrigger } = useContext(BackStageContext);

  const customRequest: UploadProps['customRequest'] = useCallback(
    async ({ file, onSuccess }) => {
      const formData = new FormData();
      formData.append('files', file);
      Message.loading({ content: '上傳中...', duration: 0 });
      try {
        await axios.patch('/ezcon/api/chargingPileListPageData', formData, {
          headers: {
            authorization: localStorage.getItem('feathers-jwt'),
          },
        });
        Message.success('上傳成功');
        onSuccess();
        setBackStageUpdateTrigger({});
      } catch (err) {
        Message.error('上傳失敗');
        console.error(err);
      }
    },
    [setBackStageUpdateTrigger]
  );

  return (
    <Upload
      accept=".xlsx, .xls"
      customRequest={customRequest}
      itemRender={() => null}
    >
      <Button>匯入充電樁列表Excel</Button>
    </Upload>
  );
};

export default UploadExcel;
